import { ItemCategoryTypes, PartTypes } from '@/enums'
import { QuoteItemModel } from '@/classes/viewmodels'
import { roundAwayFromZero } from '@/components/utils/AccountingFunctions'

export async function syncPartPaintLoading({
  partItem,
  quoteEntity,
  nextLineNumber,
  ntarLoadingItems,
  quoteInsurer,
  getDefaultPaintItem,
  deletePaintLoadingItem,
  defaultPaintGroup = ''
}) {
  if (!partItem || !quoteEntity || !ntarLoadingItems || !quoteInsurer) {
    return
  }

  const linkedItem = quoteEntity.labours.find((i) => i.linkedItemId === partItem.quoteItemId && i.isLoadItem && !i.deleted)
  let ntarLoadingItem = ntarLoadingItems.find((n) => n.itemNo === partItem.itemNo && n.category === 'PRT')
  if (!ntarLoadingItem && partItem.side) {
    ntarLoadingItem = ntarLoadingItems.find((n) => n.itemNo === `${partItem.itemNo}${partItem.side}` && n.category === 'PRT')
  }

  const isUsedOrExchange = partItem.mark === PartTypes.USED.value || partItem.mark === PartTypes.EXCH.value
  const hasPaintLoading = ntarLoadingItem && isUsedOrExchange
  if (!hasPaintLoading && !linkedItem) {
    return
  }
  if (linkedItem && !isUsedOrExchange) {
    deletePaintLoadingItem(linkedItem)
    return
  }

  let paintItem = quoteEntity.labours.find((i) => i.itemType === ItemCategoryTypes.PAINT && i.itemNo === ntarLoadingItem.raItemNo && !i.deleted)
  let paintHour = 0
  if (!paintItem) {
    const paintItems = await getDefaultPaintItem(ntarLoadingItem.raItemNo)
    if (!paintItems || paintItems.length === 0) {
      return
    }
    paintItem = paintItems[0]
    paintHour = paintItem.paintHour
  } else {
    paintHour = paintItem.hourValue
  }

  const paintLoadingItemNo = (parseInt(ntarLoadingItem.raItemNo, 10) + 5000).toString()
  let paintLoadingItem =
    linkedItem ||
    quoteEntity.labours.find((p) => p.itemType === ItemCategoryTypes.PAINT && p.itemNo === paintLoadingItemNo && p.isLoadItem && !p.deleted)
  let isNew = false

  let loadingValueType = ''
  if (partItem.mark === PartTypes.USED.value) {
    loadingValueType = 3
  } else if (partItem.mark === PartTypes.EXCH.value) {
    loadingValueType = 2
  }
  const loadingValue = quoteInsurer.insurerLoadingValues.find((v) => v.category === 'PRT' && v.loadingValueType === loadingValueType)
  const loadingPercent = (!loadingValue ? 0 : loadingValue.value) * 100
  partItem.loadingPercent = loadingPercent

  if (!paintLoadingItem) {
    paintLoadingItem = new QuoteItemModel(quoteEntity.quoteId, paintLoadingItemNo, `Paint Loading, ${partItem.itemDesc}`, ItemCategoryTypes.PAINT)
    paintLoadingItem.sortNo = quoteEntity.parts.length ? Math.max(...quoteEntity.parts.map((i) => i.sortNo)) + 1 : 1
    isNew = true
  }

  paintLoadingItem.lineNumber = nextLineNumber
  paintLoadingItem.isLoadItem = true
  paintLoadingItem.linkedItemId = partItem.quoteItemId
  paintLoadingItem.hourValue = roundAwayFromZero((paintHour * partItem.loadingPercent) / 100)
  paintLoadingItem.rate = quoteEntity.shopRate
  paintLoadingItem.dollarValue = roundAwayFromZero(paintLoadingItem.hourValue * quoteEntity.shopRate)
  if (defaultPaintGroup) {
    paintLoadingItem.opgCode = defaultPaintGroup
  }
  partItem.linkedItemId = paintLoadingItem.quoteItemId

  if (isNew) {
    quoteEntity.labours.splice(quoteEntity.labours.length, 1, paintLoadingItem)
    quoteEntity.lines = paintLoadingItem.lineNumber + 1
  }
}
